import { render } from "./StockTransactionList.vue?vue&type=template&id=12481dc2"
import script from "./StockTransactionList.vue?vue&type=script&lang=js"
export * from "./StockTransactionList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__